import React from 'react';
import { Typography, Spin } from 'antd';

export const Page404 = () => (
  <Typography>
    <Typography.Title><Spin size="large" /></Typography.Title>
  </Typography>
);
